import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { wa, componentTypes } from 'apps/analytics';
import { priceFormat } from 'apps/products/utils/priceFormat';

import PageComponent from 'apps/analytics/components/PageComponent';
import FopRibbon from 'apps/fops/components/FopRibbon';
import SectionType from 'apps/catalogue/models/SectionType';
import Icon from 'widgets/Icon/Icon';

const COUPONS_PAGE_LINK = '/webshop/coupons.go?src=on-offer-promo-fop';

function linkClicked() {
  wa.triggerPageEventWithDescription('Coupons promo FOP - see all clicked');
}

export default function CouponsPromoFop({ totalPotentialSavings, totalCouponsCount }) {
  const heading = `You have ${totalCouponsCount} coupon${totalCouponsCount === 1 ? '' : 's'}`;

  return (
    <li className="fops-item">
      <PageComponent id="coupons-promo-fop" type={componentTypes.COUPONS_PROMO_FOP} />
      <FopRibbon sectionType={SectionType.PERSONALISED_COUPONS} idx={0} />
      <Link
        to={COUPONS_PAGE_LINK}
        onClick={linkClicked}
        className="gn-content cou-promoFop"
      >
        <div>
          <h3 className="gn-content__subheader cou-promoFop__heading">{heading}</h3>
          <p className="cou-promoFop__info">Save up to {priceFormat({ value: totalPotentialSavings })} on your shop.</p>
        </div>
        <div className="cou-promoFop__ctaWrapper">
          <span className="cou-promoFop__cta">Start saving</span>
          <Icon name="chevron-right" className="cou-promoFop__chevron" />
          <Icon name="chevron-right" className="cou-promoFop__chevron cou-promoFop__chevron--hover" />
        </div>
      </Link>
    </li>
  );
}

CouponsPromoFop.propTypes = {
  totalPotentialSavings: PropTypes.number.isRequired,
  totalCouponsCount: PropTypes.number.isRequired,
};
